module.exports = __webpack_public_path__ + "static/gallery-1@2x-46f4796f43e2412677ea0619800b4c49.jpg";